"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("./api");
var empTagApi = _interopRequireWildcard(require("@/api/empTagApi"));
var _suplierCouponsApi = require("@/api/suplierCouponsApi");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t6 in e) "default" !== _t6 && {}.hasOwnProperty.call(e, _t6) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t6)) && (i.get || i.set) ? o(f, _t6, i) : f[_t6] = e[_t6]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  data: function data() {
    return {
      //弹窗
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15,
        empName: '',
        phone: '',
        dept: '',
        status: '',
        tagId: '',
        companyId: ''
      },
      loading: false,
      // 表格loading
      par: {
        name: '-'
      },
      selectedEmployees: [],
      // 选中的员工
      tagOptions: [],
      tagLoading: false,
      companyOptions: [] // 单位下拉
    };
  },
  methods: {
    getCompanyOptions: function () {
      var _getCompanyOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _suplierCouponsApi.getAllCompany)('');
            case 1:
              res = _context.v;
              this.companyOptions = Array.isArray(res) ? res : [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.companyOptions = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCompanyOptions() {
        return _getCompanyOptions.apply(this, arguments);
      }
      return getCompanyOptions;
    }(),
    downTemplate: function downTemplate() {
      this.$util.downloadTemplate('import_emp.xlsx');
    },
    //弹窗
    add: function add() {
      this.$refs.AddVueRef.open(this.par);
    },
    // 编辑
    edit: function edit(row) {
      this.$refs.AddVueRef.open(this.par, row);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(page) {
        var params, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (page) {
                this.pageFrom.page = page;
              }
              // 开启加载动画
              this.loading = true;
              // console.log('getList', this.pageFrom);
              _context2.p = 1;
              params = _objectSpread(_objectSpread({}, this.pageFrom), {}, {
                customerIntegralId: this.par.id
              });
              _context2.n = 2;
              return (0, _api.listApi)(params);
            case 2:
              res = _context2.v;
              this.tableData = res;
              this.tableData.list = res.list.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  status: item.status === 1 ? true : false
                });
              });
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              // 可根据需要做错误提示
              console.error('获取员工列表失败', _t2);
            case 4:
              _context2.p = 4;
              // 关闭加载动画
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getList(_x) {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    ChanageCpStatus: function () {
      var _ChanageCpStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var params, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                id: row.id,
                status: row.status ? 1 : 0
              };
              _context3.n = 1;
              return (0, _api.empUpdateApi)(params);
            case 1:
              res = _context3.v;
              this.$message.success('操作成功');
              this.getList();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function ChanageCpStatus(_x2) {
        return _ChanageCpStatus.apply(this, arguments);
      }
      return ChanageCpStatus;
    }(),
    //上传文件
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(excelData) {
        var _this = this;
        var results, arr, invalidCount, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              results = excelData.results;
              if (!(!results || results.length === 0)) {
                _context4.n = 1;
                break;
              }
              this.$message.warning('Excel文件中没有找到员工数据');
              return _context4.a(2);
            case 1:
              // 显示导入提示
              this.$message.info("\u5F00\u59CB\u5BFC\u5165\u5458\u5DE5\uFF0C\u5171".concat(results.length, "\u6761\u6570\u636E..."));
              arr = [];
              invalidCount = 0;
              results.forEach(function (item, index) {
                // 核对表单字段，没有的时候传空
                var empData = {
                  empName: item['员工姓名'] || item['姓名'] || item['empName'] || '',
                  phone: item['手机号'] || item['电话'] || item['phone'] || '',
                  empNo: item['工号'] || item['员工工号'] || item['empNo'] || '',
                  wechat: item['微信号'] || item['微信'] || item['wechat'] || '',
                  dept: item['部门'] || item['dept'] || '',
                  title: item['职位'] || item['职务'] || item['title'] || '',
                  workUnit: item['单位'] || item['工作单位'] || item['workUnit'] || '',
                  tagNames: item['标签'] || item['tagNames'] || ''
                };

                // 验证必填字段
                if (!empData.empName && !empData.phone) {
                  invalidCount++;
                  console.warn("\u7B2C".concat(index + 1, "\u884C\u6570\u636E\u65E0\u6548\uFF1A\u7F3A\u5C11\u5458\u5DE5\u59D3\u540D\u548C\u624B\u673A\u53F7"));
                  return;
                }
                arr.push(_objectSpread(_objectSpread({}, empData), {}, {
                  customerIntegralId: Number(_this.par.id)
                }));
              });
              if (invalidCount > 0) {
                this.$message.warning("\u53D1\u73B0".concat(invalidCount, "\u6761\u65E0\u6548\u6570\u636E\u88AB\u8DF3\u8FC7\uFF0C\u6709\u6548\u6570\u636E").concat(arr.length, "\u6761"));
              }
              if (!(arr.length === 0)) {
                _context4.n = 2;
                break;
              }
              this.$message.warning('没有找到有效的员工数据');
              return _context4.a(2);
            case 2:
              _context4.p = 2;
              _context4.n = 3;
              return (0, _api.addApi)(arr);
            case 3:
              // 导入成功提示
              this.$message.success("\u5458\u5DE5\u5BFC\u5165\u6210\u529F\uFF01\u5171\u5BFC\u5165".concat(arr.length, "\u540D\u5458\u5DE5").concat(invalidCount > 0 ? "\uFF0C\u8DF3\u8FC7".concat(invalidCount, "\u6761\u65E0\u6548\u6570\u636E") : ''));

              // 重新获取员工列表
              this.getList();
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              // 导入失败提示
              this.$message.error("\u5458\u5DE5\u5BFC\u5165\u5931\u8D25\uFF1A".concat(_t3.message || '请检查数据格式是否正确'));
              console.error('员工导入失败', _t3);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function onSuccess(_x3) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }(),
    // 选择员工变更
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedEmployees = selection;
      console.log('选中的员工:', this.selectedEmployees);
    },
    // 打开发送券包弹窗
    sendCouponPackages: function sendCouponPackages() {
      if (this.selectedEmployees.length === 0) {
        this.$message.warning('请至少选择一名员工');
        return;
      }
      this.$refs.SendCouponPackageRef.open({
        employees: this.selectedEmployees,
        customerIntegralId: this.par.id
      });
    },
    loadTagList: function loadTagList() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.tagLoading = true;
      empTagApi.getTagAutocomplete(keyword).then(function (res) {
        // const data = res.data || []
        _this2.tagOptions = res;
        _this2.tagLoading = false;
      }).catch(function () {
        _this2.tagLoading = false;
      });
    },
    handleTagSearch: function handleTagSearch(keyword) {
      // 使用节流函数进行搜索
      if (this.throttledTagSearch) {
        this.throttledTagSearch(keyword);
      } else {
        // 如果节流函数还未创建，直接调用
        this.loadTagList(keyword);
      }
    },
    // 导出员工
    export_emp: function () {
      var _export_emp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, res, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              this.loading = true;
              params = _objectSpread({}, this.pageFrom); // 移除分页参数，导出全部数据
              delete params.page;
              delete params.limit;
              _context5.n = 1;
              return (0, _api.exportEmpApi)(this.par.id, params);
            case 1:
              res = _context5.v;
              // 后端返回文件下载地址
              if (res && res.fileName) {
                window.open(res.fileName, '_blank');
                this.$message.success('导出成功');
              } else {
                this.$message.error('获取下载地址失败');
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.error('导出员工失败', _t4);
              this.$message.error('导出失败，请稍后重试');
            case 3:
              _context5.p = 3;
              this.loading = false;
              return _context5.f(3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2, 3, 4]]);
      }));
      function export_emp() {
        return _export_emp.apply(this, arguments);
      }
      return export_emp;
    }(),
    // 导出员工福豆信息
    export_emp_fudou_info: function () {
      var _export_emp_fudou_info = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var params, res, link, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              this.loading = true;
              params = _objectSpread(_objectSpread({}, this.pageFrom), {}, {
                customerIntegralId: this.par.id
              }); // 移除分页参数，导出全部数据
              _context6.n = 1;
              return (0, _api.exportUserFuCardInfo)(params);
            case 1:
              res = _context6.v;
              // 后端返回文件下载地址
              if (res && res.fileName) {
                link = document.createElement('a');
                link.href = res.fileName;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success('导出成功');
              } else {
                this.$message.error('导出失败，未获取到文件地址');
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.error('导出员工福豆信息失败', _t5);
              this.$message.error('导出失败，请稍后重试');
            case 3:
              _context6.p = 3;
              this.loading = false;
              return _context6.f(3);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2, 3, 4]]);
      }));
      function export_emp_fudou_info() {
        return _export_emp_fudou_info.apply(this, arguments);
      }
      return export_emp_fudou_info;
    }()
  },
  watch: {
    '$router.query': {
      handler: function handler(val) {
        this.getList();
        console.log(val, 'fjdshjkfk');
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.par = this.$route.query;
    this.loadTagList('');
    this.getCompanyOptions();
    this.getList();
  }
};